export const GLOW_INTENSITIES = {
  subtle: {
    label: "控えめ",
    multiplier: 0.42
  },
  standard: {
    label: "標準",
    multiplier: 0.62
  },
  strong: {
    label: "強め",
    multiplier: 0.85
  }
} as const;

export type GlowIntensity = keyof typeof GLOW_INTENSITIES;

export type MotionRenderSettings = {
  glowIntensity: GlowIntensity;
};

export const DEFAULT_RENDER_SETTINGS: MotionRenderSettings = {
  glowIntensity: "subtle"
};

export function getGlowMultiplier(settings: MotionRenderSettings = DEFAULT_RENDER_SETTINGS): number {
  return GLOW_INTENSITIES[settings.glowIntensity]?.multiplier ?? GLOW_INTENSITIES.subtle.multiplier;
}
